import React from 'react'
import {Icon} from '@chakra-ui/react'

const CardIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path d="M18 14H10V16H18V14Z" fill="currentColor" />
            <path d="M8 14H4V16H8V14Z" fill="currentColor" />
            <path
                d="M24 5C24 3.89 23.1 3 22 3H2C0.89 3 0 3.89 0 5V19C0 20.11 0.9 21 2 21H22C23.11 21 24 20.11 24 19V5ZM22 19H2V10H22V19ZM22 8H2V5H22V8Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CardIcon
